var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.46967 0.470646C0.762563 0.177753 1.23744 0.177753 1.53033 0.470646L5 3.94032L8.46967 0.470646C8.76256 0.177753 9.23744 0.177753 9.53033 0.470646C9.82322 0.76354 9.82322 1.23841 9.53033 1.53131L6.06066 5.00098L9.53033 8.47065C9.82322 8.76354 9.82322 9.23841 9.53033 9.53131C9.23744 9.8242 8.76256 9.8242 8.46967 9.53131L5 6.06164L1.53033 9.53131C1.23744 9.8242 0.762563 9.8242 0.46967 9.53131C0.176777 9.23841 0.176777 8.76354 0.46967 8.47065L3.93934 5.00098L0.46967 1.53131C0.176777 1.23841 0.176777 0.76354 0.46967 0.470646Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCloseIcon);
export default __webpack_public_path__ + "static/media/white_close_icon.2f90d5f3661a19fd61cdfd51f38feb9c.svg";
export { ForwardRef as ReactComponent };